import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import VideoPlayer from '../components/VideoPlayer';
import { toast } from 'sonner';

const OfferB = ({ userId }) => {
  const navigate = useNavigate();
  const [processing, setProcessing] = useState(false);
  const price = 20;

  const handlePurchase = () => {
    setProcessing(true);
    toast.info('Stripe checkout would open here (requires API keys)');
    setTimeout(() => {
      setProcessing(false);
    }, 2000);
  };

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      
      <main className="flex-1 container mx-auto px-4 py-12">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-8">
            <div className="inline-block px-4 py-2 bg-gold-100 text-gold-800 rounded-full text-sm font-semibold mb-4">
              Standalone Offer
            </div>
            <h2 className="text-4xl md:text-5xl font-bold mb-4" style={{color: '#3D2817'}}>
              Uganda Wildlife Safari Guide
            </h2>
            <p className="text-xl text-gray-700">
              Expert wildlife guide - Instant access!
            </p>
          </div>

          <div className="mb-8">
            <VideoPlayer videoUrl="" />
          </div>

          <div className="bg-white rounded-lg shadow-xl p-8">
            <h3 className="text-2xl font-bold mb-6" style={{color: '#D4A948'}}>
              Everything You Need for Safari:
            </h3>
            
            <div className="space-y-4 mb-8">
              <div className="flex items-start">
                <svg className="w-6 h-6 text-green-500 mr-3 flex-shrink-0 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
                <p className="text-gray-700"><strong>Gorilla tracking guide</strong> with all essential information</p>
              </div>
              <div className="flex items-start">
                <svg className="w-6 h-6 text-green-500 mr-3 flex-shrink-0 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
                <p className="text-gray-700"><strong>National parks directory</strong> with maps</p>
              </div>
              <div className="flex items-start">
                <svg className="w-6 h-6 text-green-500 mr-3 flex-shrink-0 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
                <p className="text-gray-700"><strong>Photography tips</strong> for wildlife</p>
              </div>
              <div className="flex items-start">
                <svg className="w-6 h-6 text-green-500 mr-3 flex-shrink-0 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
                <p className="text-gray-700"><strong>Instant PDF download</strong></p>
              </div>
            </div>

            <div className="bg-gradient-to-r from-gold-50 to-terracotta-50 rounded-lg p-8 text-center mb-8">
              <p className="text-gray-600 mb-2 text-lg">One-Time Payment</p>
              <div className="text-6xl font-bold mb-2" style={{color: '#D4A948'}}>
                ${price}
              </div>
              <p className="text-gray-600">Lifetime access • Instant download</p>
            </div>

            <button
              onClick={handlePurchase}
              disabled={processing}
              className="w-full py-4 rounded-lg font-bold text-white text-lg shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 transition disabled:opacity-50"
              style={{backgroundColor: '#D4A948'}}
              data-testid="purchase-offer-b"
            >
              {processing ? 'Processing...' : 'Yes I want the digital report'}
            </button>

            <div className="mt-6 text-center">
              <button
                onClick={() => navigate('/')}
                className="text-gray-600 hover:text-gray-800 font-medium"
              >
                ← Back to Home
              </button>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default OfferB;